import React from 'react';
import { Fade } from 'react-awesome-reveal';
import images from '../../assets/images';
import './Gallery.css';

const Gallery = () => {
  const handleDownload = (imageUrl, imageName) => {
    // Extract the file extension from the image URL (e.g., .jpeg, .png)
    const fileExtension = imageUrl.substring(imageUrl.lastIndexOf('.'));

    // Sanitize the image name to create a safe and valid filename
    const safeImageName = imageName.replace(/[^a-z0-9_-\s]/gi, '_').trim();

    // Combine the sanitized name and extension
    const filename = `${safeImageName}${fileExtension}`;

    fetch(imageUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Use the corrected filename
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      });
  };

  return (
    <section id="gallery" className="gallery">
      <h2>Labubu Wallpapers</h2>
      <div className="gallery-grid">
        {images.map((image) => (
          <Fade key={image.id} cascade damping={0.1} triggerOnce>
            <div className="gallery-card">
              <img src={image.src} alt={image.name} />
              <div className="card-overlay">
                <h3>{image.name}</h3>
                <button onClick={() => handleDownload(image.src, image.name)} className="download-btn">
                  Download
                </button>
              </div>
            </div>
          </Fade>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
